import ingealimentosApi, { getDomain } from '../../services/ingealimentosApi'

export const getResultAttachments = params => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get('/result_attachments', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getResultAttachment = (id, params) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get(`/result_attachments/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeResultAttachment = data => (
	new Promise((resolve, reject) => {
		ingealimentosApi('multipart/form-data')
			.post('/result_attachments', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateResultAttachment = (id, data) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.put(`/result_attachments/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteResultAttachment = id => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.delete(`/result_attachments/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchResultAttachments = async (term, token) => (
	fetch( getDomain()+`/result_attachments?filter[name]=${term}`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(item => ({
				label: item.name,
				value: item.id,
			})),
		)
)